import LegalPage from '../../components/LegalPage';
import CardNB from '../../components/ui-nb/CardNB';

export default function PrivacyPage() {
  const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <LegalPage
      title="Privacy Policy"
      lastUpdated={`Last updated: ${today}`}
    >
      <CardNB>
        <div className="space-y-8">
          <p className="text-lg text-nb-text-secondary">
            Tellow Up! ("we", "our", or "us") is committed to protecting your privacy. This policy explains how we collect, use, and safeguard your information.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Data Controller</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! is responsible for your personal data. If you have questions, contact us at privacy@tellowup.com.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Data We Collect</h2>
            <ul className="list-disc pl-5 space-y-1 text-nb-text-secondary">
              <li>Identity data: name, email address, Google OAuth information</li>
              <li>Organization data: shop name, shop code, subscription status</li>
              <li>Tracking data: release codes, repair status, timestamps</li>
              <li>Usage data: access logs, device information, IP address</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Purpose and Legal Basis</h2>
            <p className="mb-3 text-nb-text-secondary">
              We process your data to: (a) provide and maintain the service; (b) notify you about changes; (c) provide customer support; (d) detect and prevent fraud. Legal basis: consent for identity data, legitimate interest for usage analytics.
            </p>
            <p className="font-medium text-nb-text-secondary">Lawful Basis:</p>
            <ul className="list-disc pl-5 space-y-1 text-nb-text-secondary">
              <li>Provide the SaaS service</li>
              <li>Improve our platform</li>
              <li>Send service-related notifications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Data Sharing</h2>
            <p className="text-nb-text-secondary">
              We do not sell your data. We share data with: (a) Supabase (our backend provider, data stored in the US); (b) Google (OAuth authentication). All providers are bound by data processing agreements.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Payment Data</h2>
            <p className="text-nb-text-secondary">
              Payment processing is handled by Stripe. We do not store your full credit card details. Stripe may collect and process payment data according to their privacy policy. We only receive confirmation of payment status.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">International Data Transfers</h2>
            <p className="text-nb-text-secondary">
              Data may be transferred to and processed in the United States. For EU users, we ensure adequate safeguards per GDPR.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Data Retention</h2>
            <p className="text-nb-text-secondary">
              We retain your data while your account is active and for 12 months after deletion. Financial records are retained for 7 years per legal requirements.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Financial Records</h2>
            <p className="text-nb-text-secondary">
              We retain financial records for 7 years per legal requirements for tax and compliance purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Your Rights</h2>
            <p className="mb-3 text-nb-text-secondary">
              You have the right to: access, rectify, erase, restrict processing, object to processing, and port your data. Contact privacy@tellowup.com to exercise your rights.
            </p>
            <ul className="list-disc pl-5 space-y-1 text-nb-text-secondary">
              <li>Access your data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion</li>
              <li>Data portability</li>
              <li>Withdraw consent at any time</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Cookies</h2>
            <p className="text-nb-text-secondary">
              We do not use first-party cookies. Google OAuth may use cookies as per their privacy policy. We do not track users across websites.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Children's Privacy</h2>
            <p className="text-nb-text-secondary">
              Our service is not directed to users under 16. We do not knowingly collect data from children. If we learn of such collection, we will delete the data.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Changes to This Policy</h2>
            <p className="text-nb-text-secondary">
              We will notify you of changes via email or website notice. Continued use after changes constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Contact</h2>
            <p className="text-nb-text-secondary">
              For privacy concerns, contact our Data Protection Officer at privacy@tellowup.com.
            </p>
          </section>
        </div>
      </CardNB>
    </LegalPage>
  );
}
